import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Legacy `/deploy` URL 호환 리다이렉트.
 *
 * 이전 feature `site-deploy-page-split` 에서 도입된 `/deploy` 페이지가
 * `unified-site-deploy-dashboard` 에서 `/projects` 통합 대시보드로
 * 흡수됨에 따라, 기존 북마크를 자동 변환한다.
 *
 * 쿼리 매핑 규칙:
 *   (쿼리 없음)  →  ?tab=deploy
 *   ?siteId=xxx  →  ?tab=deploy&siteId=xxx       (siteId 보존)
 *   ?type=remote →  ?tab=deploy&target=remote    (인라인 다이얼로그의 target prop 이름)
 *   ?type=company→  ?tab=deploy&target=company
 *
 * 통합 대시보드의 default 탭이 'sites' (현장관리) 로 바뀌었으므로, `/deploy`
 * 북마크는 항상 `?tab=deploy` 를 명시해 사용자가 원래 보려던 배포 탭에
 * 그대로 머무르도록 한다. 리다이렉트는 `replace` 모드라 히스토리 중복이
 * 생기지 않는다.
 */
export default function DeployRedirect() {
  const [params] = useSearchParams();
  const next = new URLSearchParams();

  // 사용자의 원래 의도(배포 페이지)를 보존하기 위해 항상 tab=deploy 부착.
  next.set('tab', 'deploy');

  const siteId = params.get('siteId');
  if (siteId) next.set('siteId', siteId);

  const type = params.get('type');
  if (type === 'company' || type === 'remote') next.set('target', type);

  const to = `/projects?${next.toString()}`;

  if (typeof console !== 'undefined') {
    console.info(
      '[deprecated] /deploy 는 /projects 통합 대시보드로 이전되었습니다. →',
      to,
    );
  }

  return <Navigate to={to} replace />;
}
